import React, {useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import '../App.css';
import "./login.css"
import {showToast} from "../common/Toast";
import wsRef from '../WebSocket/wsRef';
import {useTranslation} from "react-i18next";
import globalRouter from "../globalRouter";
import {handleClose} from "../WebSocket/LogOutEvent";

const LoginForm = () => {
        const navigate = useNavigate();
        const {t} = useTranslation();
        const [searchParams] = useSearchParams();
        const [isMobile, setIsMobile] = useState(false);

        function refreshTokens() {
            return fetch(process.env.REACT_APP_BASE_URL + '/auth/refresh', {
                method: 'POST',
                credentials: 'include'
            });
        }

        function handleLogin() {
            window.location.href = `${process.env.REACT_APP_BASE_URL}/auth/login/google?redirect=${process.env.REACT_APP_SERVER}`;
            localStorage.setItem('QA', "logIn");
        }

        useEffect(() => {
            const handleConnect = (accessToken) => {
                const url = process.env.REACT_APP_SOCKET + (accessToken ? '?access_token=' + accessToken : '');
                wsRef.current = new WebSocket(url);
            }

            const abortController = new AbortController();
            const handleResize = () => {
                setIsMobile(window.innerWidth <= 768); // Adjust the breakpoint as needed
            };

            handleResize(); // Check on initial render

            window.addEventListener('resize', handleResize);

            if (searchParams.get('accessToken')) {
                let token = searchParams.get('accessToken');
                localStorage.setItem('accessToken', token);
                localStorage.setItem('QA', "active");
                navigate("/card");
                handleConnect(token);
            } else if (localStorage.getItem('QA') !== "logOut") {
                const storedAccessToken = localStorage.getItem('accessToken');
                if (storedAccessToken) {
                    navigate("/card");
                    handleConnect();
                } else {
                    if (localStorage.getItem('QA') === "logIn") {
                        refreshTokens()
                            .then(response => response.json())
                            .then(data => {
                                const accessToken = data?.data?.access_token;
                                if (!accessToken) {
                                    localStorage.removeItem("accessToken");
                                    localStorage.setItem("loggedIn", true);
                                    localStorage.setItem('QA', "logOut");
                                    globalRouter.navigate("/");
                                    handleClose();
                                    return;
                                }
                                localStorage.setItem('accessToken', accessToken);
                                localStorage.setItem('QA', "active");
                                navigate("/card");
                                handleConnect(accessToken);
                            })
                            .catch((error) => {
                                showToast(t("loginFail"), "error");
                                const storedAccessToken = localStorage.getItem('accessToken');

                                if (!storedAccessToken) {
                                    localStorage.removeItem("QA");
                                }
                            });
                    }
                }
            }
            return () => {
                window.removeEventListener('resize', handleResize);
                abortController.abort();
            };
        }, [navigate, searchParams, t]);

        return (<>
            <div
                className={`flex flex-col items-center rounded-t-lg fullHeight`}
                style={{backgroundColor: "white"}}>
                <div className="flex flex-col items-center h-max fullHeight relative">
                    <div style={{width: "50%", marginTop: "10px", marginBottom: "40px"}}>
                        <img src="/Images/login-top.png" alt=""/>
                    </div>
                    <div className="flex flex-col items-center login-content">
                        <img src="/Images/bi-logo-black.svg" alt=""/>
                        <img src="/Images/bicard-logo.png" alt="" style={{width: "50%", marginTop: "20px"}}/>
                        <button onClick={handleLogin} className="flex justify-evenly login">
                            <img src="/Images/googleIcon.svg" alt="Google icon"/>
                            <div>{t("loginGoogle")}</div>
                        </button>
                    </div>
                    <img src="/Images/login-bottom.png" alt="" style={{position: "absolute", bottom: "0", width: isMobile ? "100%" : "auto"}}/>
                </div>

            </div>
        </>);
    }
;
export default LoginForm;



